import { Resolve } from '@angular/router';
import { LoggedUserService } from './logged-user.service';
import { take } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "./logged-user.service";
var LoggedUserResolverService = /** @class */ (function () {
    function LoggedUserResolverService(loggedUserService) {
        this.loggedUserService = loggedUserService;
    }
    LoggedUserResolverService.prototype.resolve = function () {
        return this.loggedUserService.loggedUser$.pipe(take(1));
    };
    LoggedUserResolverService.ngInjectableDef = i0.defineInjectable({ factory: function LoggedUserResolverService_Factory() { return new LoggedUserResolverService(i0.inject(i1.LoggedUserService)); }, token: LoggedUserResolverService, providedIn: "root" });
    return LoggedUserResolverService;
}());
export { LoggedUserResolverService };



// WEBPACK FOOTER //
// ./src/app/core/services/logged-user-resolver.service.ts.pre-build-optimizer.js